<div class="container-fluid">

    <h4 id="upper"> Super Administrateur</h4>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div>
              <!--  -->
              <div class="d-flex align-items-center gap-3 flex-wrap">
                  <label for="categorie" class="form-label">Rechercher</label>
                  <div>
                    <label class="d-inline-flex align-items-center">
                      <input title="Rechercher par nom, prénom, email ou téléphone" type="text" [(ngModel)]="searchTerm" (input)="filterBySearchTerm()" class="form-control" id="searchMembre" placeholder="" />
  
                    </label>
                  </div>
  
                  <a  (click)="openModal()" title="Cliquez ici pour ajouter un certificat de decès"
                    style="background-color:#578D63 ;" href="javascript:void(0);" class="btn btn-success mb-2" id="gras">
                    <i class="mdi mdi-plus me-2"></i> Ajouter
                  </a>&nbsp;
                </div>
  
     
            </div>
            <div class="row mb-md-2">
  
  
              <!-- End search -->
            </div>
            <div class="table-responsive">
              <table class="table text-nowrap align-middle mb-0">
                <thead>
                  <tr class="border-2 border-bottom border-primary border-0 custom-border-bottom-medecin"
                    style="border-color: #578D63;">
                    <th scope="col" class="ps-0">Nom</th>
                    <th scope="col">Prénom</th>
                    <th scope="col">email</th>
                    <th scope="col" class="">Téléphone</th>
                    <th scope="col" class="">sexe</th>
                    <th scope="col" colspan="3" class="text-center">Action</th>
                  </tr>
                </thead>
                <tbody class="table-group-divider">
                  <tr *ngFor="let item of paginatedItems" >
                    <th scope="row" class="ps-0 fw-medium">
                      <span class="table-link1 text-truncate d-block">{{ item?.nom }} &nbsp;</span>
                    </th>
                    <td>
                      <span class="table-link1 text-truncate d-block">{{ item?.prenom }}</span>
                    </td>
                    <td>
                        <span class="table-link1 text-truncate d-block">{{ item?.email }}</span>
                      </td>
                    <td >
                      <span class="table-link1 text-truncate d-block">{{ item?.telephone }} &nbsp;</span>
                    </td>

                    <td >
                        <span class="table-link1 text-truncate d-block">{{ item?.sexe }} &nbsp;</span>
                      </td>
                    <td>
                      <a (click)="editOpenModal(item)" style="cursor: pointer;" class="me-3 text-primary" v-b-tooltip.hover title="Cliquez ici pour modifier un administrateur">
                        <i class="mdi mdi-pencil font-size-18"></i>
                      </a>
                      <a (click)="confirmSuppression(item)" href="javascript:void(0);" class="text-danger" v-b-tooltip.hover title="Cliquez ici pour retirer un administrateur">
                        <i class="mdi mdi-trash-can font-size-18"></i>
                      </a> &nbsp;&nbsp;
                    </td>
                  </tr>
                  
                </tbody>
              </table>
            </div>
  
          </div>
          <div class="d-flex justify-content-center" *ngIf="isLoading === true">
            <div class="container">
              <div class="row">
                <div class="text-center">
                  <h5 id="graycolor">Chargement en cours...</h5>
                  <div class="loader4"></div>
                </div>
              </div>
            </div>
          </div>
  
          <div *ngIf="paginatedItems.length === 0 && isLoading === false" class="d-flex justify-content-center">
            <div class="container">
              <div class="row">
                <div class="text-center">
                  <h5 id="graycolor">Aucune donnée trouvée</h5>
                </div>
              </div>
            </div>
  
          </div>
          <p-paginator (onPageChange)="onPageChange($event)" [first]="first" [rows]="rows" [totalRecords]="totalRecords"
            [rowsPerPageOptions]="[10, 20, 30]">
          </p-paginator>
        </div>
      </div>
    </div>
  
  
  </div>
  <p-toast />
  <p-confirmDialog />
  <ngx-ui-loader></ngx-ui-loader>
  